import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  usersList: {
    background: '#262736',
    padding: '21px 4px 21px 17px',
    fontSize: '14px',
    fontFamily: 'Roboto',
    lineHeight: '20px',
    color: '#FFFFFF',
    border: '1px solid rgba(255, 255, 255, 0.17)',
    height: 'auto',
    overflow: 'hidden',
    maxHeight: '500px',
  },
  usersListMinimized: {
    padding: '21px 4px 21px 18px',
    color: '#FFFFFF',
    cursor: 'pointer',
  },
  usersListSearch: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '15px',
  },
  usersListHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  usersListTitle: {
    marginLeft: '10px',
  },
  usersListSearchInput: {
    position: 'relative',
  },
  usersListSearchIcon: {
    position: 'absolute',
    left: '6px',
    top: '6px',
    color: '#3C419A',
    zIndex: 1,
  },
  contrastColor: {
    color: 'white',
  },
  usersListContainer: {
    overflow: 'hidden',
    marginTop: '15px',
  },
  usersListElement: {
    listStyle: 'none',
    paddingLeft: '13px',
    cursor: 'pointer',
    marginBottom: '18px',
  },
  emptySearchInfo: {
    display: 'flex',
    maxWidth: '240px',
    fontSize: '12px',
    fontFamily: 'Roboto',
    marginRight: '10px',
    borderRadius: '6px',
  },
  blockadeFilter: {
    marginTop: '15px',
    marginBottom: '10px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}));
